var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "25px",
    height: "25px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.52.83a.85.85 0 00-.87-.83H.87A.85.85 0 000 .83v18.34c0 .46.39.83.87.83h14.78c.48 0 .87-.37.87-.83V.83zm-8.7 7.5c.49 0 .88.38.88.84 0 .46-.4.83-.87.83a5.12 5.12 0 015.21 5H2.61c0-2.76 2.34-5 5.22-5a.85.85 0 01-.87-.83c0-.46.39-.84.87-.84zm-6.08-5h5.22V5H1.74V3.33zm0 3.34h3.48v1.66H1.74V6.67zm12.17 10H1.74v-.84H13.9v.84zm0-10.84L12.17 5l-1.74.83v-5h3.48v5zM19.13 0h-.87c.48 0 .87.37.87.83v18.34c0 .46-.39.83-.87.83h.87c.48 0 .87-.37.87-.83V.83a.85.85 0 00-.87-.83z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.26.83A.85.85 0 0017.4 0h-.87c.48 0 .87.37.87.83v18.34c0 .46-.39.83-.87.83h.87c.48 0 .87-.37.87-.83V.83z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProduction);
export default ForwardRef;